export default {"src":"/_next/static/media/Breast-Cancer-icon.75693ad7.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};